export class Pessoa {
  id?: string;
  idOriginal?: string;
  /** Código numérico do fiel no Theos (integração). */
  codigoTheos?: string | number | null;
  nome?: string;
  cpf?: string;
  /** `yyyy-MM-dd`, como o contrato manda. Data pura não tem hora nem fuso (`CTR-06`). */
  dataNascimento?: string;
  sexo?: string;
  email?: string;
  telefone?: string;
  fotoDocumentoId?: string | null;
  batizado?: boolean;
  primeiraComunhao?: boolean;
  necessidadeEspecial?: string;
  endereco?: string;
  dataPreInscricao?: string;

  constructor(data?: Partial<Pessoa>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}
